import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid, Typography, CircularProgress, Box, Avatar } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { getTenantRegistrationReportAction } from "../../Actions/ReportsAction";
import CustomSnackbar from "../Common/snackBar";

const TenantRegistrationReport = () => {
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({
        totalTenants: 0,
        activeTenants: 0,
        inactiveTenants: 0,
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const [monthlyRegistrations, setMonthlyRegistrations] =
        useState([]);

    const fetchReport = async () => {
        try {
            setLoading(true);

            const response =
                await getTenantRegistrationReportAction();

            setSummary(response?.data?.summary || {});

            setMonthlyRegistrations(
                response?.data?.monthlyRegistrations || []
            );
        } catch (error) {
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || "Something went wrong",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport();
    }, []);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    return (
        <>
            <Card>
                <CardContent>
                    {/* <Typography
                        variant="h5"
                        fontWeight={600}
                        mb={4}
                    >
                        Tenant Registration Report
                    </Typography> */}
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1.5}
                        mb={4}
                    >
                        <GroupsIcon
                            sx={{
                                color: "#22419e",
                                fontSize: 34,
                            }}
                        />

                        <Typography
                            variant="h5"
                            fontWeight={700}
                        >
                            Tenant Registration Report
                        </Typography>
                    </Box>

                    {loading ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            py={5}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            {/* Summary Cards */}

                            <Grid container spacing={3} mb={4}>
                                <Grid item xs={12} md={4}>
                                    <Card
                                        sx={{
                                            bgcolor: "#EEF4FF",
                                            boxShadow: 2,
                                        }}
                                    >
                                        <CardContent>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Total Registrations
                                            </Typography>

                                            <Typography
                                                variant="h3"
                                                fontWeight={700}
                                            >
                                                {
                                                    summary.totalTenants
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Card
                                        sx={{
                                            bgcolor: "#E8FFF3",
                                            boxShadow: 2,
                                        }}
                                    >
                                        <CardContent>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Active Tenants
                                            </Typography>

                                            <Typography
                                                variant="h3"
                                                fontWeight={700}
                                            >
                                                {
                                                    summary.activeTenants
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Card
                                        sx={{
                                            bgcolor: "#FFF5F8",
                                            boxShadow: 2,
                                        }}
                                    >
                                        <CardContent>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Inactive Tenants
                                            </Typography>

                                            <Typography
                                                variant="h3"
                                                fontWeight={700}
                                            >
                                                {
                                                    summary.inactiveTenants
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Monthly Registration Report */}
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                                }}
                            >
                                <CardContent>
                                    <Typography
                                        variant="h6"
                                        fontWeight={700}
                                        mb={3}
                                    >
                                        Monthly Registrations
                                    </Typography>

                                    <Grid container spacing={2}>
                                        {monthlyRegistrations.map((item) => (
                                            <Grid
                                                item
                                                xs={12}
                                                md={6}
                                                key={item.month}
                                            >
                                                <Box
                                                    sx={{
                                                        p: 3,
                                                        borderRadius: 3,
                                                        background:
                                                            "linear-gradient(135deg,#eef4ff,#ffffff)",
                                                        border:
                                                            "1px solid #dbeafe",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        transition: "0.3s",

                                                        "&:hover": {
                                                            transform:
                                                                "translateY(-4px)",
                                                            boxShadow:
                                                                "0 8px 20px rgba(37,99,235,0.15)",
                                                        },
                                                    }}
                                                >
                                                    {/* <Box>
                                                        <Typography
                                                            color="text.secondary"
                                                            fontSize={14}
                                                        >
                                                            Month
                                                        </Typography>

                                                        <Typography
                                                            variant="h6"
                                                            fontWeight={700}
                                                        >
                                                            {item.month}
                                                        </Typography>
                                                    </Box> */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 2,
                                                        }}
                                                    >
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: "#22419e",
                                                                width: 50,
                                                                height: 50,
                                                            }}
                                                        >
                                                            <CalendarMonthIcon />
                                                        </Avatar>

                                                        <Box>
                                                            <Typography
                                                                color="text.secondary"
                                                                fontSize={14}
                                                            >
                                                                Month
                                                            </Typography>

                                                            <Typography
                                                                variant="h6"
                                                                fontWeight={700}
                                                            >
                                                                {item.month}
                                                            </Typography>
                                                        </Box>
                                                    </Box>


                                                    <Box
                                                        sx={{
                                                            minWidth: 100,
                                                            height: 70,
                                                            borderRadius: 3,
                                                            background: "#22419e",
                                                            color: "#fff",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            px: 2,
                                                            boxShadow:
                                                                "0 6px 15px rgba(34,65,158,0.25)",
                                                        }}
                                                    >
                                                        <Typography
                                                            fontWeight={800}
                                                            fontSize={24}
                                                            lineHeight={1}
                                                        >
                                                            {item.count}
                                                        </Typography>

                                                        <Typography
                                                            fontSize={12}
                                                            mt={0.5}
                                                        >
                                                            Registrations
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </>
                    )}
                </CardContent>
            </Card>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};

export default TenantRegistrationReport;